import { Component,Input, OnInit, OnDestroy } from '@angular/core';
import { ExportOfferInformationDetail } from 'src/app/domain/models/ExportOffer';
import { ImportRequest, ImportRequestInformation } from 'src/app/domain/models/ImportRequest';

import { ExportOfferUtils } from 'src/app/ui/util/export-offer-utils';

@Component({
  selector: 'app-import-request-carousel',
  templateUrl: './import-request-carousel.component.html',
  styleUrls: ['./import-request-carousel.component.css']
})
export class ImportRequestCarouselComponent implements OnInit, OnDestroy  {

  @Input()
  offer: ImportRequestInformation | ExportOfferInformationDetail | undefined

  @Input()
  offerAd: ImportRequest | undefined

  activeIndex: number = 0
  displayBasic: boolean = false

  responsiveOptions: any = [
    {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '991px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
    }
  ]

  position: string = "left"

  getPictures(): any {
    if(this.offer){

      if(this.offer?.pictures && this.offer?.pictures.length > 0){
        return this.offer.pictures
      }

      if(this.offer?.pictures && this.offer?.pictures.length > 0)
        return this.offer.pictures

      return []
    }
    else if(this.offerAd){

      if(this.offerAd?.pictures && this.offerAd?.pictures.length > 0)
      {
        return this.offerAd.pictures
      }

      return []
    }
    return []
  }

  completeUrl(url: string): string{
    if(url)
      return ExportOfferUtils.completeUrl(url);
    return ''
  }


  isMobile: boolean = false;

  ngOnInit() {
    this.checkDeviceType(); // Comprobar el tipo de dispositivo al iniciar
    window.addEventListener('resize', this.onResize.bind(this)); // Escuchar el evento resize
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.onResize.bind(this)); // Limpiar el evento al destruir el componente
  }

  // Función para actualizar la variable isMobile
  onResize() {
    this.checkDeviceType();
  }

  // Función para comprobar si el tamaño de la pantalla es de dispositivo móvil
  checkDeviceType() {
    if(window.innerWidth <= 600){
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  imageClick(id: number)
  {
    let pictures = this.getPictures();

    let index = pictures.findIndex((x: any) => x.id == id);
    if(index != -1){

      this.activeIndex = index;
      this.displayBasic = true;
    }

  }


}
